// extracted by mini-css-extract-plugin
export var ContentWrapper = "style-module--ContentWrapper--e818c";
export var Footer = "style-module--Footer--a57f4";
export var Links = "style-module--Links--2e0f2";